import { createSlice } from "@reduxjs/toolkit"
import { candidateRetrieveJob, candidateRetrieveJobs, candidateRetrieveTenant, candidateRetriveResume } from "./CandidateJobAction"
import { Job } from "../../../../AdminPortal/scenes/Job/interface"
import { Resume } from "../interface"
import { Tenant } from "../../../../AdminPortal/scenes/Tenant/interface"

const initialState = {
  job: {} as Job,
  jobList: [],
  totalRecords: undefined,
  resume: {} as Resume,
  tenant: {} as Tenant
}

const jobSlicer = createSlice({
  name: 'candidate-job',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(candidateRetrieveJobs.fulfilled, (state: any, { payload }) => {
        state.jobList = payload.content
        state.totalRecords = Number(payload.totalElements)
      })
      .addCase(candidateRetrieveJob.fulfilled, (state: any, { payload }) => {
        state.job = payload
      })
      .addCase(candidateRetriveResume.fulfilled, (state: any, { payload }) => {
        state.resume = payload
      })
      .addCase(candidateRetrieveTenant.fulfilled, (state: any, { payload }) => {
        state.tenant = payload
      })
  },
})

export default jobSlicer.reducer